cb.define([], function() {
  const enablestatus = "false";
  const disablestatus = "true";
  var AA_aa_orgtree_VM_extend = {

    doAction: function(name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function(viewmodel) {
      var self = this;
      viewmodel.on("beforeDelete", function() {
        return self.beforeDelete(viewmodel);
      });
      viewmodel.getTreeModel().setState('maxLevel', false);
      viewmodel.on("afterLoadData", function(data) {
        viewmodel.get('parent_name').setState('maxLevel', false);
      });
      viewmodel.on("beforeSave", function() {
        var stopstatus = viewmodel.get("stopstatus").getValue();
        let status = self.beforeSave(viewmodel);
        if (status && (stopstatus === true || stopstatus === disablestatus)) {
          // cb.utils.loadingControl.start();
          // viewmodel.get("btnAdd").setDisabled(true);
          var returnPromise = new cb.promise();
          cb.utils.confirm('您确定停用当前组织和所有下级组织？', function() {
            return returnPromise.resolve();
          }, function() {
            // cb.utils.loadingControl.end();
            // viewmodel.get("btnAdd").setDisabled(false);
            returnPromise.reject();
          });
          return returnPromise;
        } else {
          return status;
        }
      });
      viewmodel.on("afterSave", function(data) {
        // cb.utils.loadingControl.end();
        // viewmodel.get("btnAdd").setDisabled(false);
        self.afterSave(viewmodel, data);
      });
      // 编辑组织,选择上级组织之前，判断，选定的组织是否已经是当前组织的下级组织
      viewmodel.get("parent_name").on("beforeValueChange", function(data) {
        if (!data.value) {
          return false
        }
        let currentOrgId = viewmodel.get("id").getValue();
        if (data.value && data.value.length == 0) // 组织参照未选中任何组织节点
          return false;
        if (!currentOrgId) { // 当前组织节点没有上级组织，说明是新增的组织节点
          return true;
        }
        if (data.value.id) {
          let selectedOrgs = viewmodel.getTreeModel().getSelectedNodes(); //当前左树选中的节点，可以认为是当前正在编辑的节点
          return self.canChoose(data.value.id || null, selectedOrgs[0]);
        } else {
          return false
        }
      });
      viewmodel.get("aa_orgtree_000001").on("afterSelect", function(data) {
        if (data[0] && !data[0].parent) { // 根节点
          viewmodel.get("code").setDisabled(true);
          viewmodel.get("name").setDisabled(true);
          viewmodel.get("fullname").setDisabled(true);
          viewmodel.get("parent_name").setDisabled(true);
          viewmodel.get("stopstatus").setDisabled(true);
          if (viewmodel.get("btnDelete")) {
            viewmodel.get("btnDelete").setDisabled(true);
          }
        } else {
          viewmodel.get("code").setDisabled(false);
          viewmodel.get("name").setDisabled(false);
          viewmodel.get("fullname").setDisabled(false);
          viewmodel.get("parent_name").setDisabled(false);
          viewmodel.get("stopstatus").setDisabled(false);
        }
        if (data[0] && data[0].stopstatus) { //组织停用了，新增按钮不可以点击
          if (viewmodel.get("btnAdd"))
            viewmodel.get("btnAdd").setDisabled(true);
        } else if (data[0] && !data[0].stopstatus) { //组织启用了，新增按钮可以点击
          if (viewmodel.get("btnAdd"))
            viewmodel.get("btnAdd").setDisabled(false);
        }
      });
      viewmodel.on("modeChange", function(data) {
        if (data == "add") {
          //新增状态:新增按钮+删除按钮不可编辑
          if (viewmodel.get("btnAdd"))
            viewmodel.get("btnAdd").setDisabled(true);
          if (viewmodel.get("btnDelete"))
            viewmodel.get("btnDelete").setDisabled(true);
          // 如果从根组织点击新增，需要将不允许编辑的字段设置为可以编辑
          viewmodel.get("code").setDisabled(false);
          viewmodel.get("name").setDisabled(false);
          viewmodel.get("fullname").setDisabled(false);
          viewmodel.get("parent_name").setDisabled(false);
          viewmodel.get("stopstatus").setDisabled(false);
        } else if (data == "edit") {
          if (viewmodel.get("btnAdd"))
            viewmodel.get("btnAdd").setDisabled(false);
          if (viewmodel.get("btnDelete"))
            viewmodel.get("btnDelete").setDisabled(false);
          self.setFieldUnEditable(viewmodel);
        }
      })
      viewmodel.get('customerName').on('beforeValueChange', (args) => {
        let mode = viewmodel.getParams().mode;
        if (mode !== 'add' && args.oldValue && args.oldValue.id) {
          let proxy = cb.rest.DynamicProxy.create({ _label: { url: '/api/org/checkCustProducts/' + args.oldValue.id, method: 'GET' } });
          let beforeSavePromise = new cb.promise();
          proxy._label({}, (err, args) => {
            if (err) {
              cb.utils.alert(err.message, 'error');
              beforeSavePromise.reject();
            }
            if (args.exists) {
              cb.utils.confirm("是否继续修改客户？", function() {
                beforeSavePromise.resolve();
              }, function() {
                beforeSavePromise.reject();
              });
            } else {
              beforeSavePromise.reject();
            }
          })
          return beforeSavePromise;
        }
      })
    },
    // 根节点，不可以修改字段
    setFieldUnEditable: function(viewmodel) {
      var selectedNode = viewmodel.get("aa_orgtree_000001").getSelectedNodes()[0];
      if (selectedNode && selectedNode.parent) { //有上级，非根组织
        viewmodel.get("code").setDisabled(false);
        viewmodel.get("name").setDisabled(false);
        viewmodel.get("fullname").setDisabled(false);
        viewmodel.get("parent_name").setDisabled(false);
        viewmodel.get("stopstatus").setDisabled(false);
      } else { //无上级，根组织
        viewmodel.get("code").setDisabled(true);
        viewmodel.get("name").setDisabled(true);
        viewmodel.get("fullname").setDisabled(true);
        viewmodel.get("parent_name").setDisabled(true);
        viewmodel.get("stopstatus").setDisabled(true);
      }
    },

    canChoose: function(chosenOrgId, org) {
      if (chosenOrgId === org.id) {
        cb.utils.alert('只能选择上级组织！', 'warning');
        return false;
      }
      if (org.children) {
        for (var i = 0, len = org.children.length; i < len; i++) {
          if (this.canChoose(chosenOrgId, org.children[i])) continue;
          return false;
        }
      }
      return true;
    },
    beforeDelete: function(viewmodel) {
      var selectedNode = viewmodel.get("aa_orgtree_000001").getSelectedNodes()[0];
      if (!selectedNode.parent) {
        cb.utils.alert("根节点不允许删除！", 'warning');
        return false;
      }
    },
    beforeSave: function(viewmodel) {
      // 组织保存前校验：上级组织不可以为空！
      // 特殊处理：根组织的上级组织可以为空
      // 新增状态，上级组织肯定都不能为空；在编辑状态下，有可能编辑的是根组织，也有可能不是根组织
      // 编辑状态下，由于上级组织是直接带出来的，而且上级组织这个参照不允许为空，所以这里不需要再次去校验上级组织是否为空了
      let mode = viewmodel.getParams().mode;
      var parent = viewmodel.get("parent").getValue();
      if (mode == "add" && !parent) {
        cb.utils.alert("上级组织不允许为空！", 'warning');
        return false;
      }
      let stopstatus = viewmodel.get("stopstatus").getValue();
      if (stopstatus === false || stopstatus === enablestatus) {
        // 检查 当前组织是否允许启用
        if (!this.checkCanOpen(viewmodel)) {
          return false;
        }
      }
      return true;
    },
    afterSave: function(viewmodel, data) {
      if (data.res) {
        viewmodel.get("pubts").setValue(data.res.pubts);
        let stopstatus = data.res.stopstatus;
        if (stopstatus === true || stopstatus === disablestatus) {
          //停用父节点，子节点全部都需要停用
          var selectedOrg = viewmodel.getTreeModel().getSelectedNodes();
          var treeModel = viewmodel.getTreeModel();
          treeModel.updateNodeRecursive(selectedOrg[0], "stopstatus", true);
          // 新增按钮置灰
          viewmodel.get("btnAdd").setDisabled(true);
        } else {
          viewmodel.get("btnAdd").setDisabled(false);
        }
      }
    },
    //保存前，校验是否允许启用
    checkCanOpen: function(viewmodel) {
      //若上级组织已经停用，则该组织不允许启用
      let treeModel = viewmodel.getTreeModel();
      let parent = viewmodel.get("parent").getValue();
      if (parent) {
        let parentNode = treeModel.getNodesByKeys([parent])[0];
        if (parentNode.stopstatus === true || parentNode.stopstatus === disablestatus) {
          cb.utils.alert("上级组织已停用，无法启用当前组织！", "error");
          viewmodel.get("stopstatus").setValue(false);
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    }
  }
  try {
    module.exports = AA_aa_orgtree_VM_extend;
  } catch (error) {

  }
  return AA_aa_orgtree_VM_extend;
});


// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_orgtree_VM.Extend.js